import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _65ba08d6 = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _fabc13d0 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _73991b14 = () => interopDefault(import('../pages/categories.vue' /* webpackChunkName: "pages/categories" */))
const _d573cbe0 = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _71a705bd = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _028aa820 = () => interopDefault(import('../pages/orders/index.vue' /* webpackChunkName: "pages/orders/index" */))
const _1c84a842 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _0e7b7ccc = () => interopDefault(import('../pages/signin.vue' /* webpackChunkName: "pages/signin" */))
const _0d589810 = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _b25b190a = () => interopDefault(import('../pages/collections/_collection.vue' /* webpackChunkName: "pages/collections/_collection" */))
const _0a379af0 = () => interopDefault(import('../pages/orders/_id.vue' /* webpackChunkName: "pages/orders/_id" */))
const _3853406d = () => interopDefault(import('../pages/products/_category/index.vue' /* webpackChunkName: "pages/products/_category/index" */))
const _78153ca8 = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _4ce74650 = () => interopDefault(import('../pages/products/_category/_id/index.vue' /* webpackChunkName: "pages/products/_category/_id/index" */))
const _733955cc = () => interopDefault(import('../pages/products/_category/_id/_product.vue' /* webpackChunkName: "pages/products/_category/_id/_product" */))
const _d12e53ec = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _65ba08d6,
    name: "about-us"
  }, {
    path: "/cart",
    component: _fabc13d0,
    name: "cart"
  }, {
    path: "/categories",
    component: _73991b14,
    name: "categories"
  }, {
    path: "/collections",
    component: _d573cbe0,
    name: "collections"
  }, {
    path: "/forgot-password",
    component: _71a705bd,
    name: "forgot-password"
  }, {
    path: "/orders",
    component: _028aa820,
    name: "orders"
  }, {
    path: "/products",
    component: _1c84a842,
    name: "products"
  }, {
    path: "/signin",
    component: _0e7b7ccc,
    name: "signin"
  }, {
    path: "/signup",
    component: _0d589810,
    name: "signup"
  }, {
    path: "/collections/:collection",
    component: _b25b190a,
    name: "collections-collection"
  }, {
    path: "/orders/:id",
    component: _0a379af0,
    name: "orders-id"
  }, {
    path: "/products/:category",
    component: _3853406d,
    name: "products-category"
  }, {
    path: "/reset-password/:token?",
    component: _78153ca8,
    name: "reset-password-token"
  }, {
    path: "/products/:category/:id",
    component: _4ce74650,
    name: "products-category-id"
  }, {
    path: "/products/:category/:id/:product",
    component: _733955cc,
    name: "products-category-id-product"
  }, {
    path: "/",
    component: _d12e53ec,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
